import React from 'react'

const BrandStyleSheet = (props) => {

  return (
    <>
      {props.brandStyleSheet &&
      <link href={`${props.brandStyleSheet}`} rel="stylesheet"/>}
    </>
  )
}

export default BrandStyleSheet
